import { TitleCard } from "@/layouts/styles/ssr.style";
import { definitions } from "@/services/metruyenvl";
import React, { useEffect, useState } from "react";
import NotificationItem from "./notification-item";
import notificationApi from "@/services/notification_api";

function NotificationTab({ user }: { user: definitions["do.UserDO"] }) {
    const [listNotification, setListNotification] = useState<definitions["models.UserNotification"][]>([]);
    const getNoti = async () => {
        try {
            const res = await notificationApi.getNotification(1, 10);
            setListNotification(res.data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getNoti();
    }, []);
    return (
        <div>
            <TitleCard> Thông báo</TitleCard>
            {listNotification?.map((item) => {
                return <NotificationItem item={item} key={item.id} />;
            })}
        </div>
    );
}

export default NotificationTab;
